import React, { useMemo } from 'react';
import { BadgeSize, BadgeVariant, StyledBadge } from './Badge.styles';
import { MarginProps } from '../../../theme/styledProps';
import { Icon } from '../Icon/Icon';

export interface BadgeProps extends MarginProps {
  children: number | string | React.ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  maxDigits?: number;
  leftIcon?: string;
  rightIcon?: string;
}

export const Badge = ({
  variant = 'primary',
  size = 'small',
  maxDigits,
  leftIcon,
  rightIcon,
  children,
  ...rest
}: BadgeProps) => {
  const parsedValue = useMemo(() => {
    if (
      typeof children === 'number' &&
      maxDigits &&
      maxDigits !== 1 &&
      children >= 10 * (maxDigits - 1)
    ) {
      return `${'9'.repeat(maxDigits - 1)}+`;
    }

    return children;
  }, [maxDigits, children]);

  return (
    <StyledBadge variant={variant} size={size} {...rest}>
      {leftIcon && <Icon className={leftIcon} />}

      {parsedValue}

      {rightIcon && <Icon className={rightIcon} />}
    </StyledBadge>
  );
};
